import type { UiKey } from "./enMessages";

/** Spanish UI — same keys as English. */
export const esMessages: Record<UiKey, string> = {
  "meta.description":
    "DMeterLine — calculadora gratuita de costes AWS y LLM: estima el gasto mensual en la nube (Lambda, API Gateway, DynamoDB, RDS, tokens) antes del lanzamiento. Planificación orientativa para equipos de producto.",
  "meta.keywords":
    "calculadora costes AWS, estimación precios AWS, coste nube, serverless coste, Lambda DynamoDB RDS, coste LLM, OpenAI API coste, precio tokens GPT, presupuesto infraestructura, coste hosting SaaS, FinOps, DMeterLine",
  "lang.switch.uk": "UA",
  "lang.switch.en": "EN",
  "lang.switch.es": "ES",
  "lang.aria": "Idioma de la interfaz",

  "hero.eyebrow": "Antes de construir → cuánto costará",
  "hero.title": "DMeterLine",
  "hero.lede.before": "Describe la funcionalidad en texto. Análisis → estructura. ",
  "hero.lede.strong": "Fórmulas",
  "hero.lede.after": " calculan AWS + LLM, no adivinanzas del modelo.",
  "hero.disclaimer":
    "Solo una estimación orientativa — no es la facturación real de AWS u otros proveedores.",

  "accuracy.title": "¿Qué tan precisa es la estimación?",
  "accuracy.lead":
    "Sirve para comparar escenarios y el orden de magnitud — no como previsión de tu factura real de AWS o del proveedor de LLM.",
  "accuracy.pt1":
    "El modelo simplifica la arquitectura (duración Lambda, patrones DynamoDB, precio de tokens mixto, etc.) y no ve tu tráfico real.",
  "accuracy.pt2":
    "Los precios son orientativos públicos — sin tus descuentos, capacidad reservada, Free Tier ni el detalle de Cost Explorer.",
  "accuracy.pt3":
    "Región y stack usan multiplicadores y configuraciones típicas, no una copia exacta de tu cuenta.",
  "accuracy.pt4":
    "El campo de factura real sirve para contrastar el modelo con lo que pagas de verdad.",
  "accuracy.bandsSimple":
    "Modo simple: el rango bajo el total es amplio a propósito (~0,48×–1,92× respecto al punto) para reflejar incertidumbre.",
  "accuracy.bandsTechnical":
    "Modo técnico: banda más estrecha (~0,86×–1,14×) alrededor del mismo modelo — sigue siendo orientativo, no un presupuesto ni SLA.",

  "mode.planning": "Planificación",
  "mode.description": "Descripción",
  "mode.aria": "Cómo defines la carga de trabajo",

  "planning.title": "Parámetros de carga",
  "planning.hint":
    "Números y funciones directas → la misma forma de workload que tras el análisis. Costes con fórmulas.",
  "planning.usersDaily": "Usuarios activos diarios (DAU)",
  "planning.requestsPerUser": "Acciones / llamadas API por usuario y día",
  "planning.features": "Funciones de arquitectura",
  "planning.feat.chat": "Chat / mensajes",
  "planning.feat.storage": "Almacenamiento de datos",
  "planning.feat.search": "Búsqueda / historial",
  "planning.feat.ai": "IA / LLM en peticiones",
  "planning.feat.realtime": "Tiempo real / WebSocket",
  "planning.feat.files": "Archivos / almacenamiento de objetos",
  "planning.aiSection": "Parámetros LLM",
  "planning.promptTokens": "Tokens prompt (media)",
  "planning.completionTokens": "Tokens de salida (media)",
  "planning.aiShare": "Parte de peticiones que van al LLM",

  sampleInput: `App de chat:
- 10k usuarios al día
- 100 mensajes por usuario
- mensajes guardados
- historial de búsqueda
- respuestas IA con GPT`,

  "form.title": "Descripción de la funcionalidad",
  "form.hint":
    "MVP: analizador heurístico (sin API). Luego el mismo JSON desde un LLM en Lambda.",
  "form.submit": "Analizar → workload",
  "form.tryPlanningTemplates": "Plantillas y controles rápidos",
  "form.tryPlanningHint":
    "Sin escribir mucho — POC, MVP, chat y más en la pestaña Planificación.",
  "form.jsonLabel": "Workload estructurado (entrada por reglas)",

  "breakdown.title": "💰 Desglose de costes",
  "breakdown.total": "Total (orientativo)",
  "breakdown.perMonth": "/ mes",

  "whatif.title": "What-if",
  "whatif.subPlanning":
    "Multiplicadores sobre el workload base del formulario (no cambian los campos).",
  "whatif.subDescription":
    "Multiplicadores tras analizar el texto (no editan el texto).",
  "whatif.users": "Usuarios / día:",
  "whatif.requests": "Acciones / usuario:",
  "whatif.liveTotal": "Total en vivo",

  "scaling.title": "📈 Escalado (workload base × usuarios)",
  "scaling.sub": "Curva desde el workload base; ejes — usuarios/día y $/mes.",
  "scaling.chartAria": "Gráfico de coste al escalar",
  "scaling.barTitle": "{{users}} usuarios → {{usd}} USD/mes",
  "scaling.legend": "Ahora: ~{{dau}} DAU — barra más cercana resaltada",

  "cp.title": "Coste vs rendimiento",
  "cp.cheaper": "Más barato",
  "cp.balanced": "Equilibrado",
  "cp.faster": "Más rápido",

  "rec.risks": "⚠️ Riesgos",
  "rec.risksEmpty": "Sin banderas críticas con las reglas actuales.",
  "rec.suggestions": "🔧 Optimizaciones",
  "rec.effort": "esfuerzo:",
  "rec.arch": "🏗️ Pistas de arquitectura",

  "footer.note":
    "Estimaciones orientativas — contrasta con facturas reales de AWS/OpenAI.",
  "footer.legal":
    "DMeterLine ofrece solo previsiones de gasto indicativas con supuestos simplificados y precios públicos de referencia. No es presupuesto oficial, oferta comercial, garantía de coste ni asesoramiento fiscal, contable o legal. Los cargos reales dependen de tarifas, región, descuentos, capas gratuitas, uso real y cambios de condiciones. El operador no es responsable de decisiones, contratos o pérdidas basadas solo en esta herramienta.",
  "export.legalHeading": "Descargo de responsabilidad",
  "footer.contactLead": "Licencias, empresa o compra — ",
  "footer.contactAria": "Enviar correo",

  "title.suffix": " — antes de construir",

  "error.title": "Algo salió mal",
  "error.body":
    "Prueba a recargar la página. Si sigue fallando, revisa la consola o envía este texto al soporte.",
  "error.retry": "Recargar",

  "effort.low": "bajo",
  "effort.medium": "medio",
  "effort.high": "alto",

  "toolbar.region": "Región AWS (multiplicador)",
  "toolbar.regionHelp":
    "Factor aproximado vs us-east-1; todos los importes del desglose se escalan.",
  "toolbar.budgetCap": "Presupuesto mensual (USD, opcional)",
  "toolbar.budgetPlaceholder": "ej. 500",
  "toolbar.exportTitle": "Informe",
  "share.title": "Escenario",
  "share.hint": "Comparte enlace o archivo JSON — no hace falta cuenta AWS.",
  "share.copyLink": "Copiar enlace",
  "share.linkCopied": "Enlace copiado",
  "share.linkTooLong":
    "El escenario es demasiado grande para un enlace — usa Descargar JSON.",
  "share.exportJson": "Descargar JSON",
  "share.importJson": "Importar JSON",
  "share.importAria": "Importar escenario desde archivo JSON",
  "share.importOk": "Escenario cargado.",
  "share.importInvalid": "JSON no válido o versión no admitida.",
  "region.af-south-1": "af-south-1 — Ciudad del Cabo",
  "region.ap-east-1": "ap-east-1 — Hong Kong",
  "region.ap-northeast-1": "ap-northeast-1 — Tokio",
  "region.ap-northeast-2": "ap-northeast-2 — Seúl",
  "region.ap-northeast-3": "ap-northeast-3 — Osaka",
  "region.ap-south-1": "ap-south-1 — Mumbai",
  "region.ap-south-2": "ap-south-2 — Hyderabad",
  "region.ap-southeast-1": "ap-southeast-1 — Singapur",
  "region.ap-southeast-2": "ap-southeast-2 — Sídney",
  "region.ap-southeast-3": "ap-southeast-3 — Yakarta",
  "region.ap-southeast-4": "ap-southeast-4 — Melbourne",
  "region.ca-central-1": "ca-central-1 — Montreal",
  "region.eu-central-1": "eu-central-1 — Fráncfort",
  "region.eu-central-2": "eu-central-2 — Zúrich",
  "region.eu-north-1": "eu-north-1 — Estocolmo",
  "region.eu-south-1": "eu-south-1 — Milán",
  "region.eu-south-2": "eu-south-2 — España",
  "region.eu-west-1": "eu-west-1 — Irlanda",
  "region.eu-west-2": "eu-west-2 — Londres",
  "region.eu-west-3": "eu-west-3 — París",
  "region.il-central-1": "il-central-1 — Tel Aviv",
  "region.me-central-1": "me-central-1 — EAU",
  "region.me-south-1": "me-south-1 — Baréin",
  "region.sa-east-1": "sa-east-1 — São Paulo",
  "region.us-east-1": "us-east-1 — N. Virginia (EE. UU.)",
  "region.us-east-2": "us-east-2 — Ohio",
  "region.us-west-1": "us-west-1 — N. California",
  "region.us-west-2": "us-west-2 — Oregón",

  "budget.over":
    "Total orientativo {{total}} supera tu tope {{cap}} / mes. Revisa what-if y optimizaciones.",

  "export.copy": "Copiar Markdown",
  "export.download": "Descargar .md",
  "export.downloadHtml": "Descargar HTML (gráficos)",
  "export.printHint":
    "Abre el archivo en el navegador. Para PDF: Imprimir → Guardar como PDF.",
  "export.colItem": "Partida",
  "export.colPct": "Parte",
  "export.colUsd": "USD / mes",
  "export.workloadSection": "Workload (JSON)",
  "export.assumptionsHeading": "Supuestos del modelo",
  "export.copied": "Copiado",
  "export.failed": "Error al copiar",
  "export.downloadPdf": "Descargar PDF",
  "export.pdfBusy": "Generando PDF…",
  "export.pdfError":
    "No se pudo generar el PDF. Prueba HTML → Imprimir en el navegador.",
  "export.appendix.trustTitle": "Confianza, versiones y auditoría",
  "export.appendix.modelVersion": "Versión del modelo",
  "export.appendix.schemaVersion": "Versión de esquema del escenario",
  "export.appendix.coefficientsDate": "Coeficientes actualizados el",
  "export.appendix.referencesTitle": "Referencias de precios (supuestos)",
  "export.appendix.snapshotTitle":
    "Instantánea de la estimación (palancas al exportar)",
  "export.appendix.region": "Región AWS",
  "export.appendix.audience": "Modo de vista / audiencia",
  "export.appendix.llmProfile": "Perfil de precio LLM",
  "export.appendix.computeProfile": "Perfil de cómputo",
  "export.appendix.displayCurrency": "Moneda mostrada en la UI",
  "export.appendix.budgetCap": "Tope de presupuesto",
  "export.appendix.budgetNone": "Ninguno",
  "export.appendix.savingsOn": "Palancas de ahorro activas",
  "export.appendix.savingsNone": "Ninguna activa",
  "export.appendix.stackTitle": "Stack de despliegue",
  "export.appendix.notesTitle": "Notas del escenario",
  "export.appendix.disclaimer":
    "Los totales del informe están modelados en USD con precios públicos y heurísticas; el EUR (si se muestra) es solo tipo de cambio orientativo.",
  "export.readonlyBanner":
    "Instantánea solo lectura — abre la app principal para editar supuestos. Las cifras son orientativas, no una factura.",
  "export.copyNotion": "Copiar Markdown para Notion",
  "export.downloadReadonlyHtml": "Descargar HTML solo lectura",
  "export.downloadPackMd": "Paquete de escenarios (.md)",
  "export.downloadPackJson": "Paquete de escenarios (.json)",
  "export.notionCopied": "Markdown para Notion copiado",

  "trust.panelTitle": "¿Por qué fiarse de estas cifras?",
  "trust.panelLead":
    "Versionamos modelo y esquema, fechamos cambios de coeficientes y enlazamos precios públicos. Los export incluyen auditoría de región, stack e interruptores.",
  "trust.coefficientsLabel": "Coeficientes actualizados",
  "trust.link.calculator": "Calculadora de precios de AWS",
  "trust.link.pricing": "Precios públicos de AWS",
  "trust.link.docs": "Resumen de facturación AWS",

  "enterprise.title": "Enterprise (próximamente)",
  "enterprise.lead":
    "Enlaces cortos estables (backend), Slack / webhooks, notas sincronizadas, CSV de Cost Explorer y SSO más profundo — en la hoja de ruta.",
  "enterprise.b1": "Enlaces cortos estables y espacios de org",
  "enterprise.b2": "Webhook / Slack con resumen del escenario",
  "enterprise.b3": "Notion / Confluence vía API",
  "enterprise.b4": "Comentarios al escenario con sync de equipo",
  "enterprise.b5": "Ingesta CSV / CUR para real vs modelo",

  "share.previewOpen": "Abrir vista previa solo lectura",
  "share.scenarioNotesLabel": "Notas (local + export JSON)",
  "share.scenarioNotesPlaceholder": "Supuestos, contexto, enlaces…",

  "preview.title": "Vista previa del escenario",
  "preview.subtitle":
    "Totales orientativos desde el hash compartido — no se escribe nada en este navegador hasta abrir el editor completo.",
  "preview.invalid":
    "Enlace ausente o no válido. Usa «Copiar enlace» en la app principal o importa JSON.",
  "preview.openFull": "Abrir editor completo",

  "toolbar.displayCurrency": "Moneda mostrada",
  "toolbar.currencyUsd": "USD (modelo)",
  "toolbar.currencyEur": "EUR (orientativo)",
  "toolbar.currencyEurHint":
    "~0,92 EUR por 1 USD solo para mostrar; el modelo sigue en USD.",

  "csv.importButton": "Importar CSV de Cost Explorer (total)",
  "csv.importHint":
    "Suma aproximada de un CSV de AWS — rellena «factura real» y, si el archivo tiene columna de servicio, muestra comparación por líneas abajo.",
  "csv.importOk": "Total del CSV reconocido.",
  "csv.importBad": "No se pudo interpretar el total del CSV.",
  "csv.compare.title": "Factura vs modelo (por categoría)",
  "csv.compare.hint":
    "Los nombres de servicio del CSV se mapean de forma heurística a las líneas del modelo — no es una conciliación con Cost Explorer.",
  "csv.compare.colLine": "Línea",
  "csv.compare.colModel": "Modelo / mes",
  "csv.compare.colCsv": "CSV / mes",
  "csv.compare.colDelta": "Δ vs modelo",
  "csv.compare.unmapped": "Otros (servicios sin mapear)",
  "csv.compare.clear": "Borrar desglose CSV",

  "namedScenarios.packHint":
    "Exporta todas las instantáneas guardadas más el escenario actual en una tabla Markdown o JSON.",
  "namedScenarios.packColScenario": "Escenario",
  "namedScenarios.packColTotal": "Total mensual (USD)",
  "namedScenarios.currentLabel": "Actual (editor)",

  "nav.footerAria": "Sitio",
  "nav.home": "Estimador",
  "nav.howItWorks": "Cómo funciona",
  "nav.privacy": "Privacidad",
  "nav.terms": "Términos",
  "nav.sidebarAria": "Navegación principal",
  "nav.menuOpen": "Abrir menú",
  "nav.menuClose": "Cerrar menú",
  "nav.collapseSidebar": "Ocultar barra lateral",
  "nav.expandSidebar": "Mostrar barra lateral",
  "nav.sidebarTagline": "AWS y LLM orientativos — antes de lanzar.",
  "nav.sidebarStripAria": "Destacados",
  "nav.sidebarPill1": "Con fórmulas",
  "nav.sidebarPill2": "AWS + LLM",
  "nav.sidebarPill3": "Exportar y compartir",
  "nav.viewModeHint":
    "Vista Simple / Técnica: usa el interruptor VIEW en el menú izquierdo (abre la barra si está oculta).",
  "scrollTop.aria": "Volver arriba",

  "doc.how.title": "Cómo funciona DMeterLine",
  "doc.how.body": `DMeterLine convierte una descripción breve o números de planificación en una carga de trabajo estructurada (usuarios, peticiones, funciones, uso opcional de LLM) y aplica precios públicos simplificados al estilo AWS y tokens de LLM.

El resultado es solo orientativo: no es tu factura de AWS, ni una oferta, ni asesoramiento legal o fiscal. Las regiones aplican un multiplicador aproximado frente a us-east-1; el stack de despliegue añade o quita partidas (API Gateway, Lambda, DynamoDB, RDS, CloudFront, etc.).

Usa «Comparar con factura real» para ver la diferencia porcentual frente al modelo. Exporta informes o comparte JSON sin necesidad de cuenta en la nube.

Mejoramos fórmulas y textos con el tiempo; verifica siempre con facturas reales antes de compromisos.`,

  "doc.privacy.title": "Privacidad",
  "doc.privacy.body": `DMeterLine funciona como aplicación web en el cliente. Los datos del escenario se guardan en tu navegador (localStorage) para recordar entradas. Esta versión no incluye inicio de sesión ni base de usuarios.

Si se activa analítica opcional (p. ej. Plausible) en la configuración del sitio, el proveedor puede procesar estadísticas básicas según su política, normalmente sin cookies.

No pegues secretos, credenciales ni datos personales en el estimador. Los enlaces y JSON compartidos codifican tu escenario; trátalos como documentación sensible.

Contacta por el correo del pie para dudas de privacidad.`,

  "doc.terms.title": "Términos de uso",
  "doc.terms.body": `Al usar DMeterLine aceptas que todas las cifras son estimaciones con supuestos simplificados. El operador no garantiza exactitud, idoneidad para un fin concreto ni coincidencia con facturas futuras.

La herramienta no sustituye asesoramiento profesional de arquitectura, seguridad, cumplimiento, fiscal, contable o legal. Eres responsable de las decisiones tomadas con estas estimaciones.

El servicio se ofrece «tal cual» sin garantías en la medida permitida por la ley. La responsabilidad se limita en la medida máxima permitida para una herramienta gratuita de este tipo.

Estos términos pueden actualizarse; el uso continuado implica aceptación de los cambios.`,

  "meta.ogTitleSuffix": "planificación orientativa de costes AWS y LLM",

  "breakdown.linesMonthlyHint":
    "Las partidas siguen en USD/mes; solo el resumen total cambia según la vista elegida.",
  "breakdown.showTotalAs": "Mostrar el total resumido como",
  "breakdown.unit.month": "/ mes",
  "breakdown.unit.year": "/ año",
  "breakdown.unit.perDau": "/ DAU / mes",
  "breakdown.unit.perMillionReq": "/ 1M peticiones",
  "breakdown.unitSuffix.month": "/ mes (igual que las partidas)",
  "breakdown.unitSuffix.year": "/ año (×12)",
  "breakdown.unitSuffix.perDau": "/ usuario activo / mes",
  "breakdown.unitSuffix.perMillionReq": "/ 1M peticiones / mes",

  "llmProfile.title": "Perfil de precio LLM",
  "llmProfile.hint":
    "Nivel aproximado frente a las tarifas base de tokens (no es una cotización en vivo). Se combina con la palanca «LLM más barato».",
  "llmProfile.economy": "Económico",
  "llmProfile.standard": "Estándar",
  "llmProfile.premium": "Premium",

  "computeProfile.title": "Perfil de cómputo de la carga",
  "computeProfile.hint":
    "CPU: proxy base de Lambda/egress. Estilo GPU: multiplicadores mayores (heurística — no precio de instancia con GPU).",
  "computeProfile.cpu": "CPU / API",
  "computeProfile.gpu": "Estilo GPU",

  "regionCompare.title": "Mismo escenario, todas las regiones",
  "regionCompare.hint":
    "Totales orientativos con la carga, stack, ahorros, perfil LLM y perfil de cómputo actuales. La región seleccionada aparece resaltada.",
  "regionCompare.colRegion": "Región",
  "regionCompare.colTotal": "Total / mes",
  "regionCompare.colDelta": "vs selección",
  "regionCompare.deltaFoot":
    "Δ% es el total de esa región frente a la región seleccionada ahora (misma carga y ajustes del modelo).",

  "actualBill.title": "Comparar con factura real",
  "actualBill.hint":
    "Opcional: importe que pagaste el mes pasado (USD) para ver el % frente a este modelo (orientativo).",
  "actualBill.label": "Total mensual real (USD)",
  "actualBill.placeholder": "p. ej. 842",
  "actualBill.invalid": "Introduce un número positivo.",
  "actualBill.vsModel":
    "Real {{actual}} vs modelo {{model}} — {{pct}}% frente al modelo (positivo = pagaste más que la estimación).",

  "namedScenarios.title": "Instantáneas con nombre",
  "namedScenarios.hint":
    "Guarda hasta 5 escenarios en este navegador (mismos datos que compartir/JSON). Carga uno para reemplazar el formulario.",
  "namedScenarios.namePlaceholder": "Nombre (p. ej. Prod Q2)",
  "namedScenarios.save": "Guardar actual",
  "namedScenarios.load": "Cargar",
  "namedScenarios.delete": "Eliminar",
  "namedScenarios.empty": "Aún no hay escenarios guardados.",
  "namedScenarios.max":
    "Máximo 5; al guardar se añade arriba y se elimina el más antiguo.",

  "savings.title": "Palancas de ahorro (orientativo)",
  "savings.hint":
    "Activa Spot, Dynamo comprometido, LLM más barato o apagado en fin de semana — se actualizan totales y gráficos.",
  "savings.spot": "Spot / cómputo preemptible",
  "savings.spotHelp":
    "~58% menos en GB·s de Lambda (peticiones sin cambio). Para Batch, Fargate Spot, etc.",
  "savings.dynamo": "DynamoDB comprometido / aprovisionado",
  "savings.dynamoHelp": "~22% menos en la línea Dynamo con tráfico estable.",
  "savings.llm": "Capa LLM más barata",
  "savings.llmHelp": "~28% menos en LLM: API batch, modelo menor, caché de respuestas.",
  "savings.llmBatch": "LLM batch / API asíncrona (vs tiempo real)",
  "savings.llmBatchHelp":
    "~32% extra en la línea LLM tras economy — precio estilo batch frente a API interactiva.",
  "savings.weekends": "Apagado fines de semana (dev / staging)",
  "savings.weekendsHelp":
    "Horas EC2, workers EKS e instancia RDS en el modelo ×5/7. Lambda, almacenamiento, DNS, GuardDuty sin cambio. No para prod 24/7.",

  "stack.title": "Stack de despliegue (orientativo)",
  "stack.hint":
    "Frontend, backend y base de datos marcan el desglose. Abajo: Route 53, ALB+WAF, GuardDuty opcionales. Precios simplificados us-east-1 × región.",
  "stack.frontend": "Frontend / borde",
  "stack.frontend.apigw": "Solo API Gateway (serverless típico)",
  "stack.frontend.cloudfront": "CloudFront (CDN)",
  "stack.frontend.ec2_spa": "SPA en EC2 (nginx)",
  "stack.backend": "Backend / cómputo",
  "stack.backend.lambda": "AWS Lambda",
  "stack.backend.ec2": "EC2 (ASG orientativo)",
  "stack.backend.eks": "Amazon EKS",
  "stack.database": "Base de datos principal en el modelo",
  "stack.database.dynamo": "Solo DynamoDB",
  "stack.database.rds": "RDS (principal)",
  "stack.database.both": "DynamoDB + RDS (reparto)",
  "stack.ec2AutoCount": "Recuento EC2 desde DAU (auto)",
  "stack.ec2Class": "Tipo de instancia backend",
  "stack.ec2Count": "Número de instancias (manual)",
  "stack.rdsAutoSize": "Clase RDS desde DAU (auto)",
  "stack.rdsClass": "Clase RDS (manual)",
  "stack.rdsStorage": "Almacenamiento RDS (GB, gp3)",
  "stack.rdsMultiAz": "RDS Multi-AZ en la fórmula",
  "stack.network": "Exposición del servicio",
  "stack.network.public": "Público (API hacia internet)",
  "stack.network.private": "Privado (VPN / DX / corporativo)",
  "stack.networkHelp":
    "Privado = sin backend público; añade línea NAT/endpoints y texto de plan sobre fugas.",
  "stack.extrasTitle": "Complementos (si aplica)",
  "stack.route53": "Route 53 — dominio y DNS",
  "stack.route53Help":
    "Zona alojada + consultas. Certificados ACM públicos para ALB/CloudFront/API GW suelen ser gratis.",
  "stack.albWaf": "ALB + AWS WAF",
  "stack.albWafHelp":
    "Bal L7, ACL WAF y peticiones orientativas. Managed rule groups aparte.",
  "stack.guardDuty": "Amazon GuardDuty",
  "stack.guardDutyHelp":
    "Amenazas VPC/DNS/CloudTrail — línea simplificada; multi-cuenta aparte.",

  "load.title": "Carga aproximada",
  "load.hintSimple":
    "Actividad aproximada en lenguaje sencillo — para planificar, no es garantía de rendimiento.",
  "load.hint": "Desde workload: peticiones, RPS, parte IA — orientativo, no SLA.",
  "bottleneck.title": "Posibles cuellos de botella",

  "preset.title": "Presets rápidos",
  "preset.poc": "POC / prueba",
  "preset.mvp": "MVP inicial",
  "preset.web_app": "App web típica",
  "preset.mobile_backend": "API para móvil",
  "preset.internal_tool": "Herramienta interna / admin",
  "preset.api_light": "API ligera",
  "preset.chat_app": "App de chat",
  "preset.rag_search": "RAG / búsqueda",
  "preset.high_traffic_ai": "Alto tráfico + IA",

  "sensitivity.title": "Sensibilidad (+10%)",
  "sensitivity.dau": "DAU +10%",
  "sensitivity.req": "Acciones / usuario +10%",
  "sensitivity.aiShare": "Cuota de peticiones al LLM +10%",
  "sensitivity.tokens": "Tokens prompt/completion +10%",

  "checklist.title": "Checklist pre-lanzamiento",
  "checklist.cache_responses":
    "Cachear respuestas / APIs idempotentes donde sea posible",
  "checklist.token_budget": "Límites de tokens y timeouts para LLM",
  "checklist.billing_alarms": "Alarmas / presupuestos de facturación en AWS",
  "checklist.load_test": "Prueba de carga para el pico esperado",
  "checklist.cdn_static": "CDN para estáticos y caché en el borde",
  "checklist.async_writes": "Escrituras asíncronas / colas para picos",
  "checklist.review_reserved":
    "Revisar Reserved / Savings Plans cuando se estabilice el tráfico",

  "scenario.title": "Comparar escenarios A / B",
  "scenario.saveA": "Guardar como A",
  "scenario.saveB": "Guardar como B",
  "scenario.clearA": "Borrar A",
  "scenario.clearB": "Borrar B",
  "scenario.total": "Total / mes",
  "scenario.deltaAB": "Delta (B − A)",
  "scenario.deltaVsCurrent": "vs estimación actual",
  "scenario.empty": "Guarda dos instantáneas para comparar gasto.",
  "scenario.snapshotMeta":
    "Workload base × usuarios {{u}}×, acciones {{r}}× → {{usd}} / mes",

  "plan.title": "Plan de infraestructura (orientativo)",
  "plan.subtitle":
    "Lo habitual detrás de las cifras: VPC, borde, cómputo y datos — alineado con tu stack.",
  "plan.subtitleSimple":
    "Resumen en lenguaje sencillo y dónde suelen ir los costes. Cambia a «Técnico» para VPC, Lambda, bases y seguridad al detalle.",

  "audience.label": "Vista",
  "audience.aria": "Nivel de detalle del análisis",
  "audience.simple": "Sencillo",
  "audience.technical": "Técnico",
  "audience.hintSimple":
    "Rango de coste más amplio y texto sin jerga — ideal para presupuestos con negocio.",
  "audience.hintTechnical":
    "Banda más estrecha, carga tipo RPS y riesgos/plan para ingeniería.",
  "audience.hintSimpleSidebar": "Lenguaje claro y rango de coste más amplio.",
  "audience.hintTechnicalSidebar": "Banda más estrecha y detalle técnico.",

  "breakdown.rangeBandSimple":
    "Rango orientativo (amplio): {{low}} – {{high}} — las facturas reales varían con descuentos, región y uso.",
  "breakdown.rangeBandTechnical":
    "Banda orientativa más estrecha: {{low}} – {{high}} — no es presupuesto; aplican los supuestos del modelo.",
  "breakdown.lineRange":
    "Banda indicativa de esta línea: {{low}} – {{high}} (mismo modo de incertidumbre que el total).",

  "glossary.summary": "Glosario: DAU, GB·s, egress…",
  "glossary.termDau": "DAU",
  "glossary.defDau":
    "Usuarios activos diarios: quienes usan la app al menos un día típico. El modelo escala peticiones y almacenamiento a partir de este número.",
  "glossary.termGb": "GB·s (gigabyte-segundos)",
  "glossary.defGb":
    "Unidad de facturación de Lambda: memoria de la función × tiempo de ejecución. Más memoria o handlers más largos suben esta línea aunque el número de peticiones no cambie.",
  "glossary.termEgress": "Transferencia de datos (egress)",
  "glossary.defEgress":
    "Salida de datos de AWS a internet (o entre regiones). Respuestas de API, descargas y streaming pueden sumar egress que en facturas pequeñas no aparece como partida aparte.",

  "whatif.subAudienceSimple":
    "Los multiplicadores escalan tu escenario; el total es un punto dentro del rango amplio del desglose.",
  "whatif.subAudienceTechnical":
    "Los multiplicadores aplican al baseline; las tarjetas de sensibilidad muestran +10% DAU/peticiones sobre el mismo modelo.",

  "flow.section.model": "Parámetros del modelo",
  "flow.section.results": "Desglose y reparto",
  "flow.detailsAccuracy": "Sobre la precisión — detalles opcionales",
  "flow.detailsModel": "Opcional: ahorros, nivel de IA y stack de despliegue",
  "flow.detailsExport": "Exportar y compartir (para tu equipo)",
  "flow.detailsExpert": "Avanzado: regiones, escalado, escenarios y sensibilidad",

  "livePulse.title": "Estimación en vivo",
  "livePulse.sub":
    "Los totales y barras reaccionan al instante a los deslizadores, ahorros, perfil LLM y stack de despliegue.",
  "livePulse.sparkCaption": "Tendencia de la sesión (total mensual)",
  "livePulse.sparkAria": "Gráfico de línea del total mensual estimado en esta sesión",
  "livePulse.topCaption": "Partidas de mayor coste",
  "livePulse.empty":
    "Configura un escenario arriba para ver totales y tendencia en vivo.",

  "mix.title": "Mezcla de costes (partes)",
  "mix.pieHint":
    "El donut muestra la parte del total mensual por partida (mismos colores que la barra). Pasa el cursor para ver USD y %.",
  "mix.pieAria": "Gráfico de donut del coste mensual por partida",
  "mix.barAria": "Barra apilada del coste mensual por partida",

  "theme.aria": "Tema de color",
  "theme.light": "Claro",
  "theme.dark": "Oscuro",
};
